import { mapActions } from 'vuex';

const ChangeTitleMixin = (title) => {
    return {
        methods: {
            ...mapActions('ui', ['changeTitle'])
        },
        mounted() {
            this.changeTitle(title)
        }
    }
};
export default ChangeTitleMixin;
